import { isArray, isObject, isString, isUndefined } from './isDefined';
import searchInArray from './searchInArray';

export default function filterCustomJobs(
  jobs,
  category,
  clientCheck = false,
  client
) {
  if (isUndefined(jobs)) {
    return [];
  }
  let filteredJobs = jobs.filter(job => filterFunction(job.category, category));

  if (clientCheck) {
    if (isUndefined(client)) {
      filteredJobs = filteredJobs.reduce((arr, job) => {
        const { parameters } = job;

        if (isObject(parameters)) {
          const parametersKeys = Object.keys(parameters);

          if (parametersKeys.includes('client_id')) {
            return arr;
          }
        }
        return [...arr, job];
      }, []);
    } else {
      filteredJobs = filteredJobs.reduce((arr, job) => {
        const { parameters } = job;

        if (isObject(parameters)) {
          const parametersKeys = Object.keys(parameters);

          if (parametersKeys.includes('client_id')) {
            return [...arr, job];
          }
        }
        return arr;
      }, []);
    }
  }

  return filteredJobs;
}

function filterFunction(jobCategory, category) {
  if (isString(jobCategory)) {
    return jobCategory === category;
  }
  if (isArray(jobCategory)) {
    return searchInArray({ array: jobCategory, term: category });
  }
  return false;
}
